import { translate } from 'vue-gettext'

const { pgettext } = translate

/**
 * Delivery service options for emails
 * These are the agents responsible for sending emails
 */
export const DeliveryServices = {
    MAILUP_AGENT: {
        value: 'MailUpAgent',
        label: pgettext('delivery_service', 'MailUp'),
        color: 'primary'
    },
    MAILUP_FAST_AGENT: {
        value: 'MailUpFastAgent',
        label: pgettext('delivery_service', 'MailUp Fast'),
        color: 'success'
    },
    MAILUP_COSTA_AGENT: {
        value: 'MailUpCostaAgent',
        label: pgettext('delivery_service', 'MailUp Costa'),
        color: 'info'
    },
    MAILUP_COSTA_FAST_AGENT: {
        value: 'MailUpCostaFastAgent',
        label: pgettext('delivery_service', 'MailUp Costa Fast'),
        color: 'secondary'
    },
    BREVO_AGENT: {
        value: 'BrevoAgent',
        label: pgettext('delivery_service', 'Brevo'),
        color: 'dark'
    },
    DJANGO_DEBUG_AGENT: {
        value: 'DjangoDebugAgent',
        label: pgettext('delivery_service', 'AWS Ses'),
        color: 'warning'
    }
}

/**
 * Get all delivery service options for select dropdown
 * @returns {Array} Array of {value, label} objects
 */
export const getDeliveryServiceOptions = () => {
    return Object.values(DeliveryServices).map(service => ({
        value: service.value,
        label: service.label
    }))
}

/**
 * Get delivery service label
 * @param {string} serviceValue - The delivery service value
 * @returns {string} The label or the value itself
 */
export const getDeliveryServiceLabel = (serviceValue) => {
    const service = Object.values(DeliveryServices).find(s => s.value === serviceValue)
    return service ? service.label : serviceValue
}

/**
 * Get delivery service color
 * @param {string} serviceValue - The delivery service value
 * @returns {string} The color or 'secondary' as default
 */
export const getDeliveryServiceColor = (serviceValue) => {
    const service = Object.values(DeliveryServices).find(s => s.value === serviceValue)
    return service ? service.color : 'secondary'
}
